export default __webpack_public_path__ + "static/media/en.2afc85bb.svg";